<template>
	<div class="Obd_jdn">
		<div class="public-table-but__left">
			<div class="item">
				<!-- <em>筛选：</em> -->
				<div class="item-wp">
					<template v-if="searchShow">
						<div class="item-son">
							<el-input
								v-model="listParams.searchKey"
								placeholder="搜索关键词"
								clearable
								@keyup.enter.native="SearchAgreementList"
							></el-input>
						</div>
						<div class="item-son">
							<el-select
								v-model="listParams.protocolType"
								clearable
								filterable
								placeholder="请选择类型"
								style="width: 100%"
							>
								<el-option
									v-for="(item, index) in agreementData"
									:key="index"
									:label="item.enumName"
									:value="item.enumVal"
								></el-option>
							</el-select>
						</div>
						<div class="item-son">
							<el-select
								v-model="listParams.status"
								clearable
								placeholder="请选择状态"
								style="width: 120px"
							>
								<el-option label="正常" value="1"></el-option>
								<el-option label="禁用" value="0"></el-option>
							</el-select>
						</div>
						<div class="item-son">
							<el-button type="primary" @click="SearchAgreementList"
								>查询 <i class="el-icon-search"></i>
							</el-button>
						</div>
					</template>

					<div class="item-son" v-if="addShow">
						<el-button type="primary" @click="handleClick('add')"
							>新增 <img src="@assets/images/add-icon.png" alt="" />
						</el-button>
					</div>
				</div>
			</div>
		</div>

		<div class="public-table-data">
			<el-table
				ref="multipleTable"
				size="medium"
				:data="tableData"
				border
				style="width: 100%"
				row-key="menuId"
				v-loading="loading"
			>
				<el-table-column
					align="center"
					fixed
					label="序号"
					type="index"
					width="60"
				>
					<template slot-scope="scope">
						<span>{{ scope.$index + 1 }}</span>
					</template>
				</el-table-column>

				<el-table-column prop="name" label="标题" align="center">
				</el-table-column>

				<el-table-column prop="remark" label="备注" align="center">
				</el-table-column>
				<el-table-column prop="flag" label="标识" width="160" align="center">
				</el-table-column>
				<el-table-column
					prop="protocolTypeName"
					label="类型"
					width="100"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="companyName"
					label="主体"
					align="center"
					width="140"
				>
				</el-table-column>
				<el-table-column prop="sort" label="排序" width="100" align="center">
					<template slot-scope="scope">
						<el-input
							size="mini"
							type="text"
							placeholder="输入排序"
							v-model="scope.row.sort"
							@blur="changOrdered(scope.row.sort, scope.row.protocolInfoId)"
						></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="code" label="状态" width="100" align="center">
					<template slot-scope="scope">
						<el-switch
							:disabled="statusShow"
							v-model="scope.row.status"
							:active-value="1"
							:inactive-value="0"
							@change="changeSwitch(scope.row)"
						>
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="200" fixed="right" align="center">
					<template slot-scope="scope">
						<el-button
							v-if="editShow"
							size="mini"
							@click="handleClick('edit', scope.row)"
							type="warning"
							plain
							>编辑
						</el-button>
						<el-button
							v-if="deleteShow"
							size="mini"
							@click="handleDelete(scope.row)"
							type="primary"
							plain
							>删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="public-pagination">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pages.pageNo"
					:page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
					:page-size="pages.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>

		<!-- 编辑弹框 -->
		<el-dialog
			title="增加/编辑协议信息"
			:visible.sync="dialogVisible"
			width="980px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleForm"
					:rules="rules"
					:model="params"
					label-width="80px"
				>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<el-row type="flex">
						<el-col :span="8">
							<el-form-item label="类型" prop="protocolType">
								<el-select
									filterable
									v-model="params.protocolType"
									clearable
									placeholder="请选择协议类型"
									style="width: 100%"
								>
									<el-option
										v-for="(item, index) in agreementData"
										:key="index"
										:label="item.enumName"
										:value="item.enumVal"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item
								v-if="!params.name && !params.protocolInfoId"
								label="主体"
								prop="companyId"
							>
								<el-select
									v-model="params.companyId"
									clearable
									filterable
									placeholder="请选择协议主体(只许添加，不许修改)"
									style="width: 100%"
								>
									<el-option
										v-for="(item, index) in companyData"
										:key="index"
										:label="item.name"
										:value="item.companyId"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item v-else label="主体" prop="companyId">
								<el-select
									v-model="params.companyId"
									clearable
									disabled
									filterable
									placeholder="请选择协议主体(只许添加，不许修改)"
									style="width: 100%"
								>
									<el-option
										v-for="(item, index) in companyData"
										:key="index"
										:label="item.name"
										:value="item.companyId"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="标识" prop="flag">
								<el-input
									placeholder="请填写文章标识"
									v-model="params.flag"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row type="flex">
						<el-col :span="12">
							<el-form-item label="名称" prop="name">
								<el-input
									placeholder="请填写协议配置名称"
									v-model="params.name"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="备注" prop="remark">
								<el-input
									placeholder="请填写协议备注"
									v-model="params.remark"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="说明" prop="descr">
						<el-input
							type="textarea"
							:autosize="{ minRows: 2, maxRows: 4 }"
							placeholder="请输入说明"
							v-model="params.descr"
						>
						</el-input>
					</el-form-item>
					<el-form-item label="详情" prop="detail">
						<richText
							:keyWord="'detail'"
							:params="params"
							v-if="flag"
						></richText>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { PAGE_SIZE, FILE_ROOT } from "@config";
import richText from "../../components/richText.vue";

export default {
	components: {
		richText,
	},
	data() {
		return {
			flag: false, //销毁子组件
			listParams: {},
			params: {},
			agreementData: [],
			tableData: [],
			companyData: [],
			loading: false,
			total: 0,
			PAGE_SIZE,
			dialogVisible: false,
			// loading: false,
			clickType: "",
			pages: {
				pageNo: 1,
				pageSize: PAGE_SIZE,
			},
			rules: {
				protocolType: [
					{
						required: true,
						message: "请选择协议类型",
						trigger: "change",
					},
				],
				companyId: [
					{
						required: true,
						message: "请选择协议主体",
						trigger: "change",
					},
				],
				name: [
					{
						required: true,
						message: "请填写协议配置名称",
						trigger: "change",
					},
				],
			},
			addShow: false,
			deleteShow: false,
			editShow: false,
			statusShow: true,
			searchShow: false,
			languageCode: "",
			languageList: [],
		};
	},
	created() {
		this.queryTableData();
		this.agreementType();
		this.companyList();
		this.getPermissionButtonList();
		this.getLanguageList();
	},
	watch: {
		dialogVisible() {
			if (this.dialogVisible == false) {
				this.$refs["ruleForm"].resetFields();
				this.params = {};
			}
		},
	},
	methods: {
		getPermissionButtonList() {
			let PermissionButtonList = window.sessionStorage.getItem(
				"TaotanPermissionButton"
			);
			let arr = JSON.parse(PermissionButtonList);
			if (arr.length) {
				arr.map((item) => {
					if (item.code == "help:cfg:query") {
						this.searchShow = true;
					}
					if (item.code == "help:cfg:add") {
						this.addShow = true;
					}
					if (item.code == "help:cfg:delete") {
						this.deleteShow = true;
					}
					if (item.code == "help:cfg:edit") {
						this.editShow = true;
					}
					if (item.code == "help:cfg:status") {
						this.statusShow = false;
					}
				});
			}
		},

		handleTabClick() {
			this.flag = false;
			if (this.params.protocolInfoId) {
				this.getAgreementDetails();
			} else {
				this.$nextTick(() => {
					this.flag = true;
				});
			}
		},
		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		//设置排序
		async changOrdered(num, data) {
			const { data: resData } = await this.$get(
				`/help/sort/${data}/`,
				{
					params: {
						sort: num,
					},
				},
				{
					headers: {
						isLoading: true,
					},
				}
			);
			this.$message.success("操作成功");
			this.queryTableData();
		},
		SearchAgreementList() {
			this.pages.pageNo = 1;
			this.queryTableData();
		},
		/**
		 * 获取主列表
		 */
		async queryTableData() {
			this.loading = true;

			const { data: resData } = await this.$get("help/list", {
				params: {
					...this.listParams,
					...this.pages,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			this.tableData = resData.data;
			this.total = resData.page.count;
		},
		/**
		 * 获取协议类型
		 */
		async agreementType() {
			this.loading = true;
			const { data: resData } = await this.$get(`enums/list/HELP_CENTER_TYPE`);
			this.loading = false;
			if (resData.result != 200) return;
			this.agreementData = resData.data;
		},
		/**
		 * 主体列表（企业列表）
		 */
		async companyList() {
			this.loading = true;

			const { data: resData } = await this.$get("company/list?paging=false");
			this.loading = false;
			if (resData.result != 200) return;
			this.companyData = resData.data;
		},
		/**
		 * 修改协议状态
		 */
		async changeSwitch(b) {
			const { data: resData } = await this.$put(
				`help/info/status/${b.protocolInfoId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.$message({
				message: resData.message,
				type: "success",
			});
		},

		/**
		 * 表格按钮点击
		 */
		handleClick(type, row = {}) {
			this.clickType = type;
			this.dialogVisible = true;

			if (type == "edit") {
				//编辑
				this.params = JSON.parse(JSON.stringify(row));
				this.getAgreementDetails();
			}
			if (type == "add") {
				this.params = {};
				this.flag = false;
				this.$nextTick(() => {
					this.flag = true; //组件生命重新加载
				});
			}
		},
		//获取详情
		async getAgreementDetails() {
			const { data: resData } = await this.$get(
				`help/info/${this.params.protocolInfoId}`,
				{
					headers: {
						"Language-Code": this.languageCode,
					},
				},
				{
					headers: {
						isLoading: true,
					},
				}
			);
			if (resData.result != 200) return;
			this.params = resData.data;
			this.flag = false;
			this.$nextTick(() => {
				this.flag = true; //组件生命重新加载
			});
		},
		/**
		 * 编辑/新增
		 */
		handleEdit() {
			this.$refs.ruleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					const { data: resData } = await this.$post(
						"/help/save",
						this.params,
						{
							headers: {
								isLoading: true,
								"Language-Code": this.languageCode,
							},
						}
					);
					if (resData.result != 200) return;
					this.params.protocolInfoId = resData.data;
					this.getAgreementDetails();
					this.queryTableData();
					this.$message.success("操作成功!");
				});
			});
		},
		/**
		 * 删除
		 */
		handleDelete(row) {
			this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`help/info/${row.protocolInfoId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.queryTableData();

				this.$message.success("删除成功!");
			});
		},

		/**
		 *  分页长度改变
		 */
		handleSizeChange(val) {
			this.pages.pageNo = 1;
			this.pages.pageSize = val;

			this.queryTableData();
		},

		/**
		 *  下一页
		 */
		handleCurrentChange(val) {
			this.pages.pageNo = val;

			this.queryTableData();
		},
	},
};
</script>

<style>
.Obd_jdn .ql-toolbar .ql-container.ql-snow {
	height: 300px;
}
</style>
